var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7796 12.7556L26.5083 11.94L22.2102 1.48435C21.8024 0.497501 20.8971 0 20 0C19.1029 0 18.1976 0.497501 17.7898 1.48435L13.4917 11.94L2.22046 12.7556C0.132582 12.8698 -0.797174 15.5449 0.825822 16.9395L9.54433 24.141L6.86924 35.0616C6.42067 36.6683 7.69297 38.0058 9.10392 38.0058C9.52802 38.0058 9.96027 37.8835 10.3599 37.6225L19.8858 31.6933L29.5341 37.6225C29.9337 37.8917 30.366 38.0058 30.7738 38.0058C32.1521 38.0058 33.3755 36.6683 33.0166 35.0616L30.3415 24.141L39.1742 16.9395C40.7972 15.5449 39.8674 12.8698 37.7796 12.7556Z",
    fill: "#F0AD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.2bee7c14bf1d92921a79762c5d8e65b6.svg";
export { ForwardRef as ReactComponent };